// extracted by mini-css-extract-plugin
export var childrenContainer = "_am-0";